import { render, staticRenderFns } from "./VvpLCPrint.vue?vue&type=template&id=5786ad2e&scoped=true&"
import script from "./VvpLCPrint.vue?vue&type=script&lang=js&"
export * from "./VvpLCPrint.vue?vue&type=script&lang=js&"
import style0 from "./VvpLCPrint.vue?vue&type=style&index=0&id=5786ad2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5786ad2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
